import React from 'react';
import { useParams } from 'react-router-dom';
import Postnav from '../../components/Postnav/Postnav';
import TiendaContent from '../../components/TiendaContent/TiendaContent'; 
import Footer from '../../components/Footer/Footer'

function Tienda() {
  const { id } = useParams();

  return (
    <div>
      <div className="outheader">
        <div className="background">
          <div className="background-center-color">
            <div className="postnav-container">
              <Postnav />
            </div>
            <TiendaContent id={id} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Tienda;